"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AERIAL_MAP_CLASS = exports.STREET_MAP_CLASS = exports.gray400 = exports.black = exports.zsgColorNotification = exports.zsgColorHometypeRecentlySoldVisited = exports.zsgColorHometypePreMarketVisited = exports.zsgColorHometypeOffMarketVisited = exports.zsgColorHometypeForSaleVisited = exports.zsgColorHometypeForRentVisited = exports.zsgColorHometypeRecentlySold = exports.zsgColorHometypePreMarket = exports.zsgColorHometypeOffMarket = exports.zsgColorHometypeForSale = exports.zsgColorHometypeForRent = exports.parcelPropShape = exports.DEFAULT_MAP_CENTER = exports.GOOGLE_TILE_SIZE = exports.DEFAULT_POLYGON_PIXEL_TOLERANCE = exports.MAXIMUM_STATE_CLICK_ZOOM = exports.DEFAULT_TILT = exports.DEFAULT_ZOOM = exports.DEFAULT_HIGH_ZOOM_LEVEL = exports.DEFAULT_MAXIMUM_ZOOM = exports.DEFAULT_MINIMUM_ZOOM = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_MINIMUM_ZOOM = 4;
exports.DEFAULT_MINIMUM_ZOOM = DEFAULT_MINIMUM_ZOOM;
var DEFAULT_MAXIMUM_ZOOM = 19;
exports.DEFAULT_MAXIMUM_ZOOM = DEFAULT_MAXIMUM_ZOOM;
var DEFAULT_HIGH_ZOOM_LEVEL = 12;
exports.DEFAULT_HIGH_ZOOM_LEVEL = DEFAULT_HIGH_ZOOM_LEVEL;
var DEFAULT_ZOOM = 5;
exports.DEFAULT_ZOOM = DEFAULT_ZOOM;
var DEFAULT_TILT = 0;
exports.DEFAULT_TILT = DEFAULT_TILT;
var MAXIMUM_STATE_CLICK_ZOOM = 6; // Determined from initial testing to be a good balance of reducing points and maintaining shape.

exports.MAXIMUM_STATE_CLICK_ZOOM = MAXIMUM_STATE_CLICK_ZOOM;
var DEFAULT_POLYGON_PIXEL_TOLERANCE = 25;
exports.DEFAULT_POLYGON_PIXEL_TOLERANCE = DEFAULT_POLYGON_PIXEL_TOLERANCE;
var GOOGLE_TILE_SIZE = 256; // This lat/lng is smack dab in the middle of the good ol USA (aka somewhere in NW Kansas)

exports.GOOGLE_TILE_SIZE = GOOGLE_TILE_SIZE;
var DEFAULT_MAP_CENTER = {
  northSouthLat: 39.52,
  eastWestLng: -100.9
};
exports.DEFAULT_MAP_CENTER = DEFAULT_MAP_CENTER;

var parcelPropShape = _propTypes.default.shape({
  id: _propTypes.default.number,
  // mbr stands for minimumBoundingRectangle
  mbr: _propTypes.default.arrayOf(_propTypes.default.number),
  polygon: _propTypes.default.shape({
    holes: _propTypes.default.arrayOf(_propTypes.default.number),
    shell: _propTypes.default.arrayOf(_propTypes.default.number)
  })
}); // Colors copied from static-zsg. static-zsg is being deprecated so we are storing these here for
// now.


exports.parcelPropShape = parcelPropShape;
var zsgColorHometypeForRent = '#a357de';
exports.zsgColorHometypeForRent = zsgColorHometypeForRent;
var zsgColorHometypeForSale = '#fc384a';
exports.zsgColorHometypeForSale = zsgColorHometypeForSale;
var zsgColorHometypeOffMarket = '#aaa';
exports.zsgColorHometypeOffMarket = zsgColorHometypeOffMarket;
var zsgColorHometypePreMarket = '#0074e4';
exports.zsgColorHometypePreMarket = zsgColorHometypePreMarket;
var zsgColorHometypeRecentlySold = '#fce013';
exports.zsgColorHometypeRecentlySold = zsgColorHometypeRecentlySold;
var zsgColorHometypeForRentVisited = '#D2abef';
exports.zsgColorHometypeForRentVisited = zsgColorHometypeForRentVisited;
var zsgColorHometypeForSaleVisited = '#fe9ca4';
exports.zsgColorHometypeForSaleVisited = zsgColorHometypeForSaleVisited;
var zsgColorHometypeOffMarketVisited = '#aaa';
exports.zsgColorHometypeOffMarketVisited = zsgColorHometypeOffMarketVisited;
var zsgColorHometypePreMarketVisited = '#80BAF2';
exports.zsgColorHometypePreMarketVisited = zsgColorHometypePreMarketVisited;
var zsgColorHometypeRecentlySoldVisited = '#FDF089';
exports.zsgColorHometypeRecentlySoldVisited = zsgColorHometypeRecentlySoldVisited;
var zsgColorNotification = '#ed7318';
exports.zsgColorNotification = zsgColorNotification;
var black = '#0A0A14';
exports.black = black;
var gray400 = '#A7A6AB';
exports.gray400 = gray400;
var STREET_MAP_CLASS = 'map-street-view';
exports.STREET_MAP_CLASS = STREET_MAP_CLASS;
var AERIAL_MAP_CLASS = 'map-aerial-view';
exports.AERIAL_MAP_CLASS = AERIAL_MAP_CLASS;